import { motion } from 'framer-motion';

export default function ProfileSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="inline-block px-4 py-2 bg-teal-100 rounded-lg mb-6">
            <span className="text-sm text-teal-800 font-medium">From Managing Director</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Greeting from Managing Director
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Supporting your business with extensive experience and expertise
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start"
        >
          {/* Profile Image */}
          <div className="w-full">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/bba6f100249febdc0b7d767d96cdc56b.jpeg"
                alt="SHUJI YAMAUCHI - YPC Managing Director"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>

          {/* Profile Content */}
          <div className="space-y-8">
            <div>
              <h3 className="text-4xl font-bold text-gray-900 mb-2">
                SHUJI YAMAUCHI
              </h3>
              <p className="text-xl text-teal-600 font-medium mb-6">
                Managing Director, YPC
              </p>
            </div>

            <div className="space-y-6">
              {/* Education - Gakushuin */}
              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-graduation-cap-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">
                    学習院大学（Gakushuin Univ）卒業
                  </h4>
                  <p className="text-sm text-gray-600">
                    Earned a Bachelor's degree from a prestigious, famous Japanese Royal University in Japan (Gakushuin Univ.)
                  </p>
                </div>
              </div>

              {/* Education - Berkeley */}
              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">
                    米国バークレー大学（Berkley Univ）MBA取得
                  </h4>
                  <p className="text-sm text-gray-600">
                    Accquire MBA in USA
                  </p>
                </div>
              </div>

              {/* Career */}
              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-briefcase-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">
                    化粧品メーカー、光学機器メーカー等を経てYPCを設立
                  </h4>
                  <p className="text-sm text-gray-600">
                    Based on vast experience at a major company, I went independent and started YPC
                  </p>
                </div>
              </div>

              {/* International Experience */}
              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-1">
                    マレーシアはじめ東南アジアにおける海外進出、移住全般をサポート
                  </h4>
                  <p className="text-sm text-gray-600">
                    We utilize our strong Southeast Asia network and expertise to fully back our clients' overseas business development
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-200">
              <p className="text-base text-gray-700 leading-relaxed">
                長年の国際ビジネス経験と、マレーシアをはじめとする東南アジアでの豊富な実績を活かし、
                お客様の海外進出や移住をトータルでサポートいたします。
                お客様一人ひとりのニーズに合わせた最適なソリューションをご提案させていただきます。
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
